import React, { useState, useEffect } from 'react';



// Comprehensive salary data structure
const salaryData = {
  
  'HR Analytics': {
    seniority: [
      'HR Analytics Lead',
      'Director of Workforce Analytics/Insights',
      'HR Data & Analytics Manager',
      'Senior HR Insight Analyst',
      'HR Analytics Specialist/Workforce Data Consultant/HR Insights Lead',
      'HR Analytics Executive/HR Data Analyst/HR Reporting Analyst',
      'HR Analytics Trainee/Data Entry for HR Analytics/HR Data Coordinator'
    ],
    cityData: {
      'HR Analytics Lead': { India: 150, Bangalore: 188, Hyderabad: 168, 'Delhi NCR': 168, Pune: 165, Mumbai: 177, Chennai: 158, Kolkata: 147, 'Tier II': 135 },
      'Director of Workforce Analytics/Insights': { India: 100, Bangalore: 125, Hyderabad: 112, 'Delhi NCR': 112, Pune: 110, Mumbai: 118, Chennai: 105, Kolkata: 98, 'Tier II': 90 },
      'HR Data & Analytics Manager': { India: 60, Bangalore: 75, Hyderabad: 67, 'Delhi NCR': 67, Pune: 66, Mumbai: 71, Chennai: 63, Kolkata: 59, 'Tier II': 54 },
      'Senior HR Insight Analyst': { India: 40, Bangalore: 50, Hyderabad: 45, 'Delhi NCR': 45, Pune: 44, Mumbai: 47, Chennai: 42, Kolkata: 39, 'Tier II': 36 },
      'HR Analytics Specialist/Workforce Data Consultant/HR Insights Lead': { India: 26, Bangalore: 33, Hyderabad: 29, 'Delhi NCR': 29, Pune: 29, Mumbai: 31, Chennai: 27, Kolkata: 25, 'Tier II': 23 },
      'HR Analytics Executive/HR Data Analyst/HR Reporting Analyst': { India: 18, Bangalore: 23, Hyderabad: 20, 'Delhi NCR': 20, Pune: 20, Mumbai: 21, Chennai: 19, Kolkata: 18, 'Tier II': 16 },
      'HR Analytics Trainee/Data Entry for HR Analytics/HR Data Coordinator': { India: 12, Bangalore: 15, Hyderabad: 13.4, 'Delhi NCR': 13.8, Pune: 13.4, Mumbai: 14.4, Chennai: 13, Kolkata: 12.4, 'Tier II': 12 }
    },
    industryData: {
      'HR Analytics Lead': { 'All Industry': 150.5, 'Hi-Tech': 190, BFS: 171, 'Mfg & Auto': 146, 'Health & Pharma': 173, 'Retail & CS': 155, 'Transp & Log': 105, 'Ent & Media': 129, 'Energy & Util': 139, 'Prof Serv': 178, 'BPO/GBS': 120 },
      'Director of Workforce Analytics/Insights': { 'All Industry': 100.5, 'Hi-Tech': 135, BFS: 125, 'Mfg & Auto': 96, 'Health & Pharma': 105, 'Retail & CS': 92, 'Transp & Log': 92, 'Ent & Media': 93, 'Energy & Util': 106, 'Prof Serv': 120, 'BPO/GBS': 90 },
      'HR Data & Analytics Manager': { 'All Industry': 60.5, 'Hi-Tech': 84, BFS: 75, 'Mfg & Auto': 58, 'Health & Pharma': 66, 'Retail & CS': 55, 'Transp & Log': 54, 'Ent & Media': 55, 'Energy & Util': 63, 'Prof Serv': 72, 'BPO/GBS': 55 },
      'Senior HR Insight Analyst': { 'All Industry': 40.0, 'Hi-Tech': 56, BFS: 50, 'Mfg & Auto': 38, 'Health & Pharma': 44, 'Retail & CS': 37, 'Transp & Log': 36, 'Ent & Media': 37, 'Energy & Util': 42, 'Prof Serv': 48, 'BPO/GBS': 37 },
      'HR Analytics Specialist/Workforce Data Consultant/HR Insights Lead': { 'All Industry': 26.0, 'Hi-Tech': 37, BFS: 32, 'Mfg & Auto': 25, 'Health & Pharma': 29, 'Retail & CS': 25, 'Transp & Log': 24, 'Ent & Media': 24, 'Energy & Util': 27, 'Prof Serv': 31, 'BPO/GBS': 24 },
      'HR Analytics Executive/HR Data Analyst/HR Reporting Analyst': { 'All Industry': 18.5, 'Hi-Tech': 25, BFS: 22, 'Mfg & Auto': 17, 'Health & Pharma': 20, 'Retail & CS': 18, 'Transp & Log': 17, 'Ent & Media': 17, 'Energy & Util': 19, 'Prof Serv': 22, 'BPO/GBS': 17 },
      'HR Analytics Trainee/Data Entry for HR Analytics/HR Data Coordinator': { 'All Industry': 12.0, 'Hi-Tech': 16, BFS: 14, 'Mfg & Auto': 11, 'Health & Pharma': 13, 'Retail & CS': 11, 'Transp & Log': 11, 'Ent & Media': 11, 'Energy & Util': 13, 'Prof Serv': 14, 'BPO/GBS': 11 }
    }
  },
  'Talent Acquisition': {
    seniority: [
      'Vice President/SVP & Head of TA',
      'Senior Director Recruiter/Talent Acquisition',
      'Director Recruiter/Talent Acquisition',
      'Recruitment Manager/Talent Acquisition Manager',
      'Senior Recruiters/Talent Acquisition',
      'Executive Recruiters/Talent Acquisition',
      'Recruitment Coordinator – Lateral or Campus'
    ],
    cityData: {
      'Vice President/SVP & Head of TA': { India: 141.5, Bangalore: 184, Hyderabad: 168.4, 'Delhi NCR': 155.7, Pune: 164.1, Mumbai: 184, Chennai: 159.9, Kolkata: 150, 'Tier II': 118.9 },
      'Senior Director Recruiter/Talent Acquisition': { India: 63.0, Bangalore: 81.9, Hyderabad: 75, 'Delhi NCR': 69.3, Pune: 73.1, Mumbai: 81.9, Chennai: 71.2, Kolkata: 66.8, 'Tier II': 52.3 },
      'Director Recruiter/Talent Acquisition': { India: 46.5, Bangalore: 60.5, Hyderabad: 55.3, 'Delhi NCR': 51.2, Pune: 53.9, Mumbai: 60.5, Chennai: 52.5, Kolkata: 49.3, 'Tier II': 40.9 },
      'Recruitment Manager/Talent Acquisition Manager': { India: 23.2, Bangalore: 30.2, Hyderabad: 27.6, 'Delhi NCR': 25.5, Pune: 26.9, Mumbai: 30.2, Chennai: 26.2, Kolkata: 24.6, 'Tier II': 20.9 },
      'Senior Recruiters/Talent Acquisition': { India: 15.5, Bangalore: 20.2, Hyderabad: 18.4, 'Delhi NCR': 17.1, Pune: 18, Mumbai: 20.2, Chennai: 17.5, Kolkata: 16.4, 'Tier II': 14.1 },
      'Executive Recruiters/Talent Acquisition': { India: 10.8, Bangalore: 14, Hyderabad: 12.9, 'Delhi NCR': 11.9, Pune: 12.5, Mumbai: 14, Chennai: 12.2, Kolkata: 11.4, 'Tier II': 9.8 },
      'Recruitment Coordinator – Lateral or Campus': { India: 5.4, Bangalore: 7, Hyderabad: 6.4, 'Delhi NCR': 5.9, Pune: 6.3, Mumbai: 7, Chennai: 6.1, Kolkata: 5.7, 'Tier II': 4.9 }
    },
    industryData: {
      'Vice President/SVP & Head of TA': { 'All Industry': 141.5, 'Hi-Tech': 185, BFS: 160, 'Mfg & Auto': 138, 'Health & Pharma': 159, 'Retail & CS': 144, 'Transp & Log': 128, 'Ent & Media': 139, 'Energy & Util': 134, 'Prof Serv': 161, 'BPO/GBS': 135 },
      'Senior Director Recruiter/Talent Acquisition': { 'All Industry': 63.0, 'Hi-Tech': 89.6, BFS: 75.9, 'Mfg & Auto': 60, 'Health & Pharma': 74.7, 'Retail & CS': 63.5, 'Transp & Log': 55.2, 'Ent & Media': 62.6, 'Energy & Util': 61.7, 'Prof Serv': 73.3, 'BPO/GBS': 57.5 },
      'Director Recruiter/Talent Acquisition': { 'All Industry': 46.5, 'Hi-Tech': 65, BFS: 54.5, 'Mfg & Auto': 45.5, 'Health & Pharma': 53.7, 'Retail & CS': 47, 'Transp & Log': 39.9, 'Ent & Media': 45.9, 'Energy & Util': 44.2, 'Prof Serv': 53.7, 'BPO/GBS': 42.7 },
      'Recruitment Manager/Talent Acquisition Manager': { 'All Industry': 23.2, 'Hi-Tech': 30, BFS: 27.2, 'Mfg & Auto': 22.8, 'Health & Pharma': 27.4, 'Retail & CS': 23.5, 'Transp & Log': 20.5, 'Ent & Media': 22.9, 'Energy & Util': 22.1, 'Prof Serv': 26.9, 'BPO/GBS': 21.3 },
      'Senior Recruiters/Talent Acquisition': { 'All Industry': 15.5, 'Hi-Tech': 20.2, BFS: 20.0, 'Mfg & Auto': 16.9, 'Health & Pharma': 14.7, 'Retail & CS': 16.1, 'Transp & Log': 14.5, 'Ent & Media': 13.8, 'Energy & Util': 14.6, 'Prof Serv': 15.1, 'BPO/GBS': 15.9 },
      'Executive Recruiters/Talent Acquisition': { 'All Industry': 10.8, 'Hi-Tech': 13.4, BFS: 13.3, 'Mfg & Auto': 11.1, 'Health & Pharma': 10.1, 'Retail & CS': 10.8, 'Transp & Log': 9.8, 'Ent & Media': 8.8, 'Energy & Util': 9.4, 'Prof Serv': 12, 'BPO/GBS': 10.7 },
      'Recruitment Coordinator – Lateral or Campus': { 'All Industry': 5.4, 'Hi-Tech': 6.7, BFS: 6.3, 'Mfg & Auto': 5.6, 'Health & Pharma': 5.1, 'Retail & CS': 5.3, 'Transp & Log': 4.9, 'Ent & Media': 4.6, 'Energy & Util': 4.8, 'Prof Serv': 5.6, 'BPO/GBS': 5.4 }
    }
  },
  'Compensation & Benefits': {
    seniority: [
      'VP/Head of Compensation & Benefits',
      'Senior Director C&B',
      'Director C&B',
      'Manager C&B',
      'Senior Analyst/Lead C&B',
      'Executive/Analyst C&B',
      'Coordinator C&B'
    ],
    cityData: {
      'VP/Head of Compensation & Benefits': { India: 148, Bangalore: 185, Hyderabad: 166, 'Delhi NCR': 163, Pune: 163, Mumbai: 174, Chennai: 156, Kolkata: 148, 'Tier II': 133 },
      'Senior Director C&B': { India: 74, Bangalore: 93, Hyderabad: 83, 'Delhi NCR': 81, Pune: 81, Mumbai: 87, Chennai: 78, Kolkata: 74, 'Tier II': 67 },
      'Director C&B': { India: 50, Bangalore: 63, Hyderabad: 56, 'Delhi NCR': 55, Pune: 55, Mumbai: 59, Chennai: 53, Kolkata: 50, 'Tier II': 45 },
      'Manager C&B': { India: 28, Bangalore: 35, Hyderabad: 31, 'Delhi NCR': 31, Pune: 31, Mumbai: 33, Chennai: 30, Kolkata: 28, 'Tier II': 25 },
      'Senior Analyst/Lead C&B': { India: 19, Bangalore: 24, Hyderabad: 21, 'Delhi NCR': 21, Pune: 21, Mumbai: 22, Chennai: 20, Kolkata: 19, 'Tier II': 17 },
      'Executive/Analyst C&B': { India: 13, Bangalore: 16, Hyderabad: 15, 'Delhi NCR': 14, Pune: 14, Mumbai: 15, Chennai: 14, Kolkata: 13, 'Tier II': 12 },
      'Coordinator C&B': { India: 7, Bangalore: 9, Hyderabad: 8, 'Delhi NCR': 8, Pune: 8, Mumbai: 8, Chennai: 7, Kolkata: 7, 'Tier II': 6 }
    },
    industryData: {
      'VP/Head of Compensation & Benefits': { 'All Industry': 148, 'Hi-Tech': 185, BFS: 170, 'Mfg & Auto': 148, 'Health & Pharma': 163, 'Retail & CS': 155, 'Transp & Log': 119, 'Ent & Media': 126, 'Energy & Util': 141, 'Prof Serv': 170, 'BPO/GBS': 133 },
      'Senior Director C&B': { 'All Industry': 74, 'Hi-Tech': 93, BFS: 85, 'Mfg & Auto': 74, 'Health & Pharma': 81, 'Retail & CS': 78, 'Transp & Log': 59, 'Ent & Media': 63, 'Energy & Util': 70, 'Prof Serv': 85, 'BPO/GBS': 67 },
      'Director C&B': { 'All Industry': 50, 'Hi-Tech': 63, BFS: 58, 'Mfg & Auto': 50, 'Health & Pharma': 55, 'Retail & CS': 53, 'Transp & Log': 40, 'Ent & Media': 43, 'Energy & Util': 48, 'Prof Serv': 58, 'BPO/GBS': 45 },
      'Manager C&B': { 'All Industry': 28, 'Hi-Tech': 35, BFS: 32, 'Mfg & Auto': 28, 'Health & Pharma': 31, 'Retail & CS': 29, 'Transp & Log': 22, 'Ent & Media': 24, 'Energy & Util': 27, 'Prof Serv': 32, 'BPO/GBS': 25 },
      'Senior Analyst/Lead C&B': { 'All Industry': 19, 'Hi-Tech': 24, BFS: 22, 'Mfg & Auto': 19, 'Health & Pharma': 21, 'Retail & CS': 20, 'Transp & Log': 15, 'Ent & Media': 16, 'Energy & Util': 18, 'Prof Serv': 22, 'BPO/GBS': 17 },
      'Executive/Analyst C&B': { 'All Industry': 13, 'Hi-Tech': 16, BFS: 15, 'Mfg & Auto': 13, 'Health & Pharma': 14, 'Retail & CS': 14, 'Transp & Log': 10, 'Ent & Media': 11, 'Energy & Util': 12, 'Prof Serv': 15, 'BPO/GBS': 12 },
      'Coordinator C&B': { 'All Industry': 7, 'Hi-Tech': 9, BFS: 8, 'Mfg & Auto': 7, 'Health & Pharma': 8, 'Retail & CS': 7, 'Transp & Log': 6, 'Ent & Media': 6, 'Energy & Util': 7, 'Prof Serv': 8, 'BPO/GBS': 6 }
    }
  },
  'ER/IR': {
    seniority: [
      'VP/Head of ER-IR',
      'Senior Director ER-IR',
      'Director ER-IR',
      'Manager ER-IR',
      'Senior Lead/Specialist ER-IR',
      'Executive ER-IR',
      'Coordinator ER-IR'
    ],
    cityData: {
      'VP/Head of ER-IR': { India: 137, Bangalore: 171, Hyderabad: 154, 'Delhi NCR': 151, Pune: 151, Mumbai: 161, Chennai: 145, Kolkata: 137, 'Tier II': 123 },
      'Senior Director ER-IR': { India: 74, Bangalore: 93, Hyderabad: 83, 'Delhi NCR': 81, Pune: 81, Mumbai: 87, Chennai: 78, Kolkata: 74, 'Tier II': 67 },
      'Director ER-IR': { India: 51, Bangalore: 64, Hyderabad: 57, 'Delhi NCR': 56, Pune: 56, Mumbai: 60, Chennai: 54, Kolkata: 51, 'Tier II': 46 },
      'Manager ER-IR': { India: 30, Bangalore: 38, Hyderabad: 34, 'Delhi NCR': 33, Pune: 33, Mumbai: 35, Chennai: 32, Kolkata: 30, 'Tier II': 27 },
      'Senior Lead/Specialist ER-IR': { India: 21, Bangalore: 26, Hyderabad: 24, 'Delhi NCR': 23, Pune: 23, Mumbai: 25, Chennai: 22, Kolkata: 21, 'Tier II': 19 },
      'Executive ER-IR': { India: 15, Bangalore: 19, Hyderabad: 17, 'Delhi NCR': 17, Pune: 17, Mumbai: 18, Chennai: 16, Kolkata: 15, 'Tier II': 14 },
      'Coordinator ER-IR': { India: 9, Bangalore: 11, Hyderabad: 10, 'Delhi NCR': 10, Pune: 10, Mumbai: 11, Chennai: 10, Kolkata: 9, 'Tier II': 8 }
    },
    industryData: {
      'VP/Head of ER-IR': { 'All Industry': 137, 'Hi-Tech': 171, BFS: 157, 'Mfg & Auto': 137, 'Health & Pharma': 151, 'Retail & CS': 144, 'Transp & Log': 110, 'Ent & Media': 117, 'Energy & Util': 131, 'Prof Serv': 157, 'BPO/GBS': 123 },
      'Senior Director ER-IR': { 'All Industry': 74, 'Hi-Tech': 93, BFS: 85, 'Mfg & Auto': 74, 'Health & Pharma': 81, 'Retail & CS': 78, 'Transp & Log': 59, 'Ent & Media': 63, 'Energy & Util': 70, 'Prof Serv': 85, 'BPO/GBS': 67 },
      'Director ER-IR': { India: 51, 'Hi-Tech': 64, BFS: 58, 'Mfg & Auto': 51, 'Health & Pharma': 56, 'Retail & CS': 54, 'Transp & Log': 41, 'Ent & Media': 43, 'Energy & Util': 49, 'Prof Serv': 58, 'BPO/GBS': 46 },
      'Manager ER-IR': { 'All Industry': 30, 'Hi-Tech': 38, BFS: 34, 'Mfg & Auto': 30, 'Health & Pharma': 33, 'Retail & CS': 32, 'Transp & Log': 24, 'Ent & Media': 26, 'Energy & Util': 29, 'Prof Serv': 34, 'BPO/GBS': 27 },
      'Senior Lead/Specialist ER-IR': { 'All Industry': 21, 'Hi-Tech': 26, BFS: 24, 'Mfg & Auto': 21, 'Health & Pharma': 23, 'Retail & CS': 22, 'Transp & Log': 17, 'Ent & Media': 18, 'Energy & Util': 20, 'Prof Serv': 24, 'BPO/GBS': 19 },
      'Executive ER-IR': { 'All Industry': 15, 'Hi-Tech': 19, BFS: 17, 'Mfg & Auto': 15, 'Health & Pharma': 17, 'Retail & CS': 16, 'Transp & Log': 12, 'Ent & Media': 13, 'Energy & Util': 14, 'Prof Serv': 17, 'BPO/GBS': 14 },
      'Coordinator ER-IR': { 'All Industry': 9, 'Hi-Tech': 11, BFS: 10, 'Mfg & Auto': 9, 'Health & Pharma': 10, 'Retail & CS': 10, 'Transp & Log': 7, 'Ent & Media': 8, 'Energy & Util': 9, 'Prof Serv': 10, 'BPO/GBS': 8 }
    }
  },
  'HR Operations': {
    seniority: [
      'VP/Head of HR Operations',
      'Senior Director HR Ops',
      'Director HR Ops',
      'Manager HR Ops',
      'Senior Specialist HR Ops',
      'Executive/Analyst HR Ops',
      'Coordinator HR Ops'
    ],
    cityData: {
      'VP/Head of HR Operations': { India: 128, Bangalore: 160, Hyderabad: 144, 'Delhi NCR': 141, Pune: 141, Mumbai: 150, Chennai: 135, Kolkata: 128, 'Tier II': 115 },
      'Senior Director HR Ops': { India: 69, Bangalore: 86, Hyderabad: 78, 'Delhi NCR': 76, Pune: 76, Mumbai: 81, Chennai: 73, Kolkata: 69, 'Tier II': 62 },
      'Director HR Ops': { India: 47, Bangalore: 59, Hyderabad: 53, 'Delhi NCR': 52, Pune: 52, Mumbai: 55, Chennai: 50, Kolkata: 47, 'Tier II': 42 },
      'Manager HR Ops': { India: 26, Bangalore: 33, Hyderabad: 29, 'Delhi NCR': 29, Pune: 29, Mumbai: 31, Chennai: 28, Kolkata: 26, 'Tier II': 23 },
      'Senior Specialist HR Ops': { India: 18, Bangalore: 23, Hyderabad: 20, 'Delhi NCR': 20, Pune: 20, Mumbai: 21, Chennai: 19, Kolkata: 18, 'Tier II': 16 },
      'Executive/Analyst HR Ops': { India: 12, Bangalore: 15, Hyderabad: 13, 'Delhi NCR': 13, Pune: 13, Mumbai: 14, Chennai: 13, Kolkata: 12, 'Tier II': 11 },
      'Coordinator HR Ops': { India: 7, Bangalore: 9, Hyderabad: 8, 'Delhi NCR': 8, Pune: 8, Mumbai: 8, Chennai: 7, Kolkata: 7, 'Tier II': 6 }
    },
    industryData: {
      'VP/Head of HR Operations': { 'All Industry': 128, 'Hi-Tech': 160, BFS: 147, 'Mfg & Auto': 128, 'Health & Pharma': 141, 'Retail & CS': 134, 'Transp & Log': 102, 'Ent & Media': 109, 'Energy & Util': 122, 'Prof Serv': 147, 'BPO/GBS': 115 },
      'Senior Director HR Ops': { 'All Industry': 69, 'Hi-Tech': 86, BFS: 79, 'Mfg & Auto': 69, 'Health & Pharma': 76, 'Retail & CS': 72, 'Transp & Log': 55, 'Ent & Media': 59, 'Energy & Util': 66, 'Prof Serv': 79, 'BPO/GBS': 62 },
      'Director HR Ops': { 'All Industry': 47, 'Hi-Tech': 59, BFS: 54, 'Mfg & Auto': 47, 'Health & Pharma': 52, 'Retail & CS': 49, 'Transp & Log': 38, 'Ent & Media': 40, 'Energy & Util': 45, 'Prof Serv': 54, 'BPO/GBS': 42 },
      'Manager HR Ops': { 'All Industry': 26, 'Hi-Tech': 33, BFS: 30, 'Mfg & Auto': 26, 'Health & Pharma': 29, 'Retail & CS': 27, 'Transp & Log': 21, 'Ent & Media': 22, 'Energy & Util': 25, 'Prof Serv': 30, 'BPO/GBS': 23 },
      'Senior Specialist HR Ops': { 'All Industry': 18, 'Hi-Tech': 23, BFS: 21, 'Mfg & Auto': 18, 'Health & Pharma': 20, 'Retail & CS': 19, 'Transp & Log': 14, 'Ent & Media': 15, 'Energy & Util': 17, 'Prof Serv': 21, 'BPO/GBS': 16 },
      'Executive/Analyst HR Ops': { 'All Industry': 12, 'Hi-Tech': 15, BFS: 14, 'Mfg & Auto': 12, 'Health & Pharma': 13, 'Retail & CS': 13, 'Transp & Log': 10, 'Ent & Media': 10, 'Energy & Util': 11, 'Prof Serv': 14, 'BPO/GBS': 11 },
      'Coordinator HR Ops': { 'All Industry': 7, 'Hi-Tech': 9, BFS: 8, 'Mfg & Auto': 7, 'Health & Pharma': 8, 'Retail & CS': 7, 'Transp & Log': 6, 'Ent & Media': 6, 'Energy & Util': 7, 'Prof Serv': 8, 'BPO/GBS': 6 }
    }
  },
  'HRBP': {
    seniority: [
      'VP/Head of HRBP',
      'Senior Director HRBP',
      'Director HRBP',
      'Senior HRBP',
      'HRBP',
      'Junior HRBP',
      'HRBP Coordinator'
    ],
    cityData: {
      'VP/Head of HRBP': { India: 145, Bangalore: 181, Hyderabad: 163, 'Delhi NCR': 160, Pune: 160, Mumbai: 171, Chennai: 153, Kolkata: 145, 'Tier II': 131 },
      'Senior Director HRBP': { India: 82, Bangalore: 103, Hyderabad: 92, 'Delhi NCR': 90, Pune: 90, Mumbai: 96, Chennai: 87, Kolkata: 82, 'Tier II': 74 },
      'Director HRBP': { India: 57, Bangalore: 71, Hyderabad: 64, 'Delhi NCR': 63, Pune: 63, Mumbai: 67, Chennai: 60, Kolkata: 57, 'Tier II': 51 },
      'Senior HRBP': { India: 37, Bangalore: 46, Hyderabad: 42, 'Delhi NCR': 41, Pune: 41, Mumbai: 44, Chennai: 39, Kolkata: 37, 'Tier II': 33 },
      'HRBP': { India: 23, Bangalore: 29, Hyderabad: 26, 'Delhi NCR': 25, Pune: 25, Mumbai: 27, Chennai: 24, Kolkata: 23, 'Tier II': 21 },
      'Junior HRBP': { India: 14, Bangalore: 18, Hyderabad: 16, 'Delhi NCR': 15, Pune: 15, Mumbai: 16, Chennai: 15, Kolkata: 14, 'Tier II': 13 },
      'HRBP Coordinator': { India: 8, Bangalore: 10, Hyderabad: 9, 'Delhi NCR': 9, Pune: 9, Mumbai: 9, Chennai: 8, Kolkata: 8, 'Tier II': 7 }
    },
    industryData: {
      'VP/Head of HRBP': { 'All Industry': 145, 'Hi-Tech': 181, BFS: 166, 'Mfg & Auto': 145, 'Health & Pharma': 160, 'Retail & CS': 152, 'Transp & Log': 116, 'Ent & Media': 123, 'Energy & Util': 138, 'Prof Serv': 166, 'BPO/GBS': 131 },
      'Senior Director HRBP': { 'All Industry': 82, 'Hi-Tech': 103, BFS: 94, 'Mfg & Auto': 82, 'Health & Pharma': 90, 'Retail & CS': 86, 'Transp & Log': 66, 'Ent & Media': 70, 'Energy & Util': 78, 'Prof Serv': 94, 'BPO/GBS': 74 },
      'Director HRBP': { 'All Industry': 57, 'Hi-Tech': 71, BFS: 65, 'Mfg & Auto': 57, 'Health & Pharma': 63, 'Retail & CS': 60, 'Transp & Log': 46, 'Ent & Media': 49, 'Energy & Util': 54, 'Prof Serv': 65, 'BPO/GBS': 51 },
      'Senior HRBP': { 'All Industry': 37, 'Hi-Tech': 46, BFS: 42, 'Mfg & Auto': 37, 'Health & Pharma': 41, 'Retail & CS': 39, 'Transp & Log': 30, 'Ent & Media': 32, 'Energy & Util': 35, 'Prof Serv': 42, 'BPO/GBS': 33 },
      'HRBP': { 'All Industry': 23, 'Hi-Tech': 29, BFS: 26, 'Mfg & Auto': 23, 'Health & Pharma': 25, 'Retail & CS': 24, 'Transp & Log': 18, 'Ent & Media': 20, 'Energy & Util': 22, 'Prof Serv': 26, 'BPO/GBS': 21 },
      'Junior HRBP': { 'All Industry': 14, 'Hi-Tech': 18, BFS: 16, 'Mfg & Auto': 14, 'Health & Pharma': 15, 'Retail & CS': 15, 'Transp & Log': 11, 'Ent & Media': 12, 'Energy & Util': 13, 'Prof Serv': 16, 'BPO/GBS': 13 },
      'HRBP Coordinator': { 'All Industry': 8, 'Hi-Tech': 10, BFS: 9, 'Mfg & Auto': 8, 'Health & Pharma': 9, 'Retail & CS': 8, 'Transp & Log': 6, 'Ent & Media': 7, 'Energy & Util': 8, 'Prof Serv': 9, 'BPO/GBS': 7 }
    }
  },
  'L&D': {
    seniority: [
      'VP/Head of L&D',
      'Senior Director L&D',
      'Director L&D',
      'Manager L&D',
      'Senior Specialist/Lead L&D',
      'Executive/Analyst L&D',
      'Coordinator L&D'
    ],
    cityData: {
      'VP/Head of L&D': { India: 131, Bangalore: 164, Hyderabad: 147, 'Delhi NCR': 144, Pune: 144, Mumbai: 154, Chennai: 138, Kolkata: 131, 'Tier II': 118 },
      'Senior Director L&D': { India: 72, Bangalore: 90, Hyderabad: 81, 'Delhi NCR': 79, Pune: 79, Mumbai: 85, Chennai: 76, Kolkata: 72, 'Tier II': 65 },
      'Director L&D': { India: 49, Bangalore: 61, Hyderabad: 55, 'Delhi NCR': 54, Pune: 54, Mumbai: 58, Chennai: 52, Kolkata: 49, 'Tier II': 44 },
      'Manager L&D': { India: 28, Bangalore: 35, Hyderabad: 31, 'Delhi NCR': 31, Pune: 31, Mumbai: 33, Chennai: 30, Kolkata: 28, 'Tier II': 25 },
      'Senior Specialist/Lead L&D': { India: 19, Bangalore: 24, Hyderabad: 21, 'Delhi NCR': 21, Pune: 21, Mumbai: 22, Chennai: 20, Kolkata: 19, 'Tier II': 17 },
      'Executive/Analyst L&D': { India: 13, Bangalore: 16, Hyderabad: 15, 'Delhi NCR': 14, Pune: 14, Mumbai: 15, Chennai: 14, Kolkata: 13, 'Tier II': 12 },
      'Coordinator L&D': { India: 8, Bangalore: 10, Hyderabad: 9, 'Delhi NCR': 9, Pune: 9, Mumbai: 9, Chennai: 8, Kolkata: 8, 'Tier II': 7 }
    },
    industryData: {
      'VP/Head of L&D': { 'All Industry': 131, 'Hi-Tech': 164, BFS: 150, 'Mfg & Auto': 131, 'Health & Pharma': 144, 'Retail & CS': 137, 'Transp & Log': 105, 'Ent & Media': 112, 'Energy & Util': 125, 'Prof Serv': 150, 'BPO/GBS': 118 },
      'Senior Director L&D': { 'All Industry': 72, 'Hi-Tech': 90, BFS: 82, 'Mfg & Auto': 72, 'Health & Pharma': 79, 'Retail & CS': 76, 'Transp & Log': 58, 'Ent & Media': 61, 'Energy & Util': 69, 'Prof Serv': 82, 'BPO/GBS': 65 },
      'Director L&D': { 'All Industry': 49, 'Hi-Tech': 61, BFS: 56, 'Mfg & Auto': 49, 'Health & Pharma': 54, 'Retail & CS': 51, 'Transp & Log': 39, 'Ent & Media': 42, 'Energy & Util': 47, 'Prof Serv': 56, 'BPO/GBS': 44 },
      'Manager L&D': { 'All Industry': 28, 'Hi-Tech': 35, BFS: 32, 'Mfg & Auto': 28, 'Health & Pharma': 31, 'Retail & CS': 29, 'Transp & Log': 22, 'Ent & Media': 24, 'Energy & Util': 27, 'Prof Serv': 32, 'BPO/GBS': 25 },
      'Senior Specialist/Lead L&D': { 'All Industry': 19, 'Hi-Tech': 24, BFS: 22, 'Mfg & Auto': 19, 'Health & Pharma': 21, 'Retail & CS': 20, 'Transp & Log': 15, 'Ent & Media': 16, 'Energy & Util': 18, 'Prof Serv': 22, 'BPO/GBS': 17 },
      'Executive/Analyst L&D': { 'All Industry': 13, 'Hi-Tech': 16, BFS: 15, 'Mfg & Auto': 13, 'Health & Pharma': 14, 'Retail & CS': 14, 'Transp & Log': 10, 'Ent & Media': 11, 'Energy & Util': 12, 'Prof Serv': 15, 'BPO/GBS': 12 },
      'Coordinator L&D': { 'All Industry': 8, 'Hi-Tech': 10, BFS: 9, 'Mfg & Auto': 8, 'Health & Pharma': 9, 'Retail & CS': 8, 'Transp & Log': 6, 'Ent & Media': 7, 'Energy & Util': 8, 'Prof Serv': 9, 'BPO/GBS': 7 }
    }
  },
  'Payroll & Compliance': {
    seniority: [
      'VP/Head of Payroll & Compliance',
      'Senior Director Payroll',
      'Director Payroll',
      'Manager Payroll',
      'Senior Specialist Payroll',
      'Executive/Analyst Payroll',
      'Coordinator Payroll'
    ],
    cityData: {
      'VP/Head of Payroll & Compliance': { India: 122, Bangalore: 153, Hyderabad: 137, 'Delhi NCR': 134, Pune: 134, Mumbai: 143, Chennai: 129, Kolkata: 122, 'Tier II': 110 },
      'Senior Director Payroll': { India: 66, Bangalore: 83, Hyderabad: 74, 'Delhi NCR': 73, Pune: 73, Mumbai: 78, Chennai: 70, Kolkata: 66, 'Tier II': 59 },
      'Director Payroll': { India: 45, Bangalore: 56, Hyderabad: 50, 'Delhi NCR': 50, Pune: 50, Mumbai: 53, Chennai: 48, Kolkata: 45, 'Tier II': 41 },
      'Manager Payroll': { India: 25, Bangalore: 31, Hyderabad: 28, 'Delhi NCR': 28, Pune: 28, Mumbai: 29, Chennai: 26, Kolkata: 25, 'Tier II': 23 },
      'Senior Specialist Payroll': { India: 17, Bangalore: 21, Hyderabad: 19, 'Delhi NCR': 19, Pune: 19, Mumbai: 20, Chennai: 18, Kolkata: 17, 'Tier II': 15 },
      'Executive/Analyst Payroll': { India: 12, Bangalore: 15, Hyderabad: 13, 'Delhi NCR': 13, Pune: 13, Mumbai: 14, Chennai: 13, Kolkata: 12, 'Tier II': 11 },
      'Coordinator Payroll': { India: 7, Bangalore: 9, Hyderabad: 8, 'Delhi NCR': 8, Pune: 8, Mumbai: 8, Chennai: 7, Kolkata: 7, 'Tier II': 6 }
    },
    industryData: {
      'VP/Head of Payroll & Compliance': { 'All Industry': 122, 'Hi-Tech': 153, BFS: 140, 'Mfg & Auto': 122, 'Health & Pharma': 134, 'Retail & CS': 128, 'Transp & Log': 98, 'Ent & Media': 104, 'Energy & Util': 116, 'Prof Serv': 140, 'BPO/GBS': 110 },
      'Senior Director Payroll': { 'All Industry': 66, 'Hi-Tech': 83, BFS: 76, 'Mfg & Auto': 66, 'Health & Pharma': 73, 'Retail & CS': 69, 'Transp & Log': 53, 'Ent & Media': 56, 'Energy & Util': 63, 'Prof Serv': 76, 'BPO/GBS': 59 },
      'Director Payroll': { 'All Industry': 45, 'Hi-Tech': 56, BFS: 52, 'Mfg & Auto': 45, 'Health & Pharma': 50, 'Retail & CS': 47, 'Transp & Log': 36, 'Ent & Media': 38, 'Energy & Util': 43, 'Prof Serv': 52, 'BPO/GBS': 41 },
      'Manager Payroll': { 'All Industry': 25, 'Hi-Tech': 31, BFS: 29, 'Mfg & Auto': 25, 'Health & Pharma': 28, 'Retail & CS': 26, 'Transp & Log': 20, 'Ent & Media': 21, 'Energy & Util': 24, 'Prof Serv': 29, 'BPO/GBS': 23 },
      'Senior Specialist Payroll': { 'All Industry': 17, 'Hi-Tech': 21, BFS: 20, 'Mfg & Auto': 17, 'Health & Pharma': 19, 'Retail & CS': 18, 'Transp & Log': 14, 'Ent & Media': 14, 'Energy & Util': 16, 'Prof Serv': 20, 'BPO/GBS': 15 },
      'Executive/Analyst Payroll': { 'All Industry': 12, 'Hi-Tech': 15, BFS: 14, 'Mfg & Auto': 12, 'Health & Pharma': 13, 'Retail & CS': 13, 'Transp & Log': 10, 'Ent & Media': 10, 'Energy & Util': 11, 'Prof Serv': 14, 'BPO/GBS': 11 },
      'Coordinator Payroll': { 'All Industry': 7, 'Hi-Tech': 9, BFS: 8, 'Mfg & Auto': 7, 'Health & Pharma': 8, 'Retail & CS': 7, 'Transp & Log': 6, 'Ent & Media': 6, 'Energy & Util': 7, 'Prof Serv': 8, 'BPO/GBS': 6 }
    }
  },
  'I&D and Culture': {
    seniority: [
      'VP/Head of I&D',
      'Senior Director I&D',
      'Director I&D',
      'Manager I&D',
      'Senior Specialist I&D',
      'Executive/Analyst I&D',
      'Coordinator I&D'
    ],
    cityData: {
      'VP/Head of I&D': { India: 134, Bangalore: 168, Hyderabad: 150, 'Delhi NCR': 147, Pune: 147, Mumbai: 157, Chennai: 141, Kolkata: 134, 'Tier II': 121 },
      'Senior Director I&D': { India: 74, Bangalore: 93, Hyderabad: 83, 'Delhi NCR': 81, Pune: 81, Mumbai: 87, Chennai: 78, Kolkata: 74, 'Tier II': 67 },
      'Director I&D': { India: 51, Bangalore: 64, Hyderabad: 57, 'Delhi NCR': 56, Pune: 56, Mumbai: 60, Chennai: 54, Kolkata: 51, 'Tier II': 46 },
      'Manager I&D': { India: 29, Bangalore: 36, Hyderabad: 33, 'Delhi NCR': 32, Pune: 32, Mumbai: 34, Chennai: 31, Kolkata: 29, 'Tier II': 26 },
      'Senior Specialist I&D': { India: 20, Bangalore: 25, Hyderabad: 22, 'Delhi NCR': 22, Pune: 22, Mumbai: 24, Chennai: 21, Kolkata: 20, 'Tier II': 18 },
      'Executive/Analyst I&D': { India: 14, Bangalore: 18, Hyderabad: 16, 'Delhi NCR': 15, Pune: 15, Mumbai: 16, Chennai: 15, Kolkata: 14, 'Tier II': 13 },
      'Coordinator I&D': { India: 8, Bangalore: 10, Hyderabad: 9, 'Delhi NCR': 9, Pune: 9, Mumbai: 9, Chennai: 8, Kolkata: 8, 'Tier II': 7 }
    },
    industryData: {
      'VP/Head of I&D': { 'All Industry': 134, 'Hi-Tech': 168, BFS: 154, 'Mfg & Auto': 134, 'Health & Pharma': 147, 'Retail & CS': 140, 'Transp & Log': 107, 'Ent & Media': 114, 'Energy & Util': 128, 'Prof Serv': 154, 'BPO/GBS': 121 },
      'Senior Director I&D': { 'All Industry': 74, 'Hi-Tech': 93, BFS: 85, 'Mfg & Auto': 74, 'Health & Pharma': 81, 'Retail & CS': 78, 'Transp & Log': 59, 'Ent & Media': 63, 'Energy & Util': 70, 'Prof Serv': 85, 'BPO/GBS': 67 },
      'Director I&D': { 'All Industry': 51, 'Hi-Tech': 64, BFS: 58, 'Mfg & Auto': 51, 'Health & Pharma': 56, 'Retail & CS': 54, 'Transp & Log': 41, 'Ent & Media': 43, 'Energy & Util': 49, 'Prof Serv': 58, 'BPO/GBS': 46 },
      'Manager I&D': { 'All Industry': 29, 'Hi-Tech': 36, BFS: 33, 'Mfg & Auto': 29, 'Health & Pharma': 32, 'Retail & CS': 30, 'Transp & Log': 23, 'Ent & Media': 25, 'Energy & Util': 28, 'Prof Serv': 33, 'BPO/GBS': 26 },
      'Senior Specialist I&D': { 'All Industry': 20, 'Hi-Tech': 25, BFS: 23, 'Mfg & Auto': 20, 'Health & Pharma': 22, 'Retail & CS': 21, 'Transp & Log': 16, 'Ent & Media': 17, 'Energy & Util': 19, 'Prof Serv': 23, 'BPO/GBS': 18 },
      'Executive/Analyst I&D': { 'All Industry': 14, 'Hi-Tech': 18, BFS: 16, 'Mfg & Auto': 14, 'Health & Pharma': 15, 'Retail & CS': 15, 'Transp & Log': 11, 'Ent & Media': 12, 'Energy & Util': 13, 'Prof Serv': 16, 'BPO/GBS': 13 },
      'Coordinator I&D': { 'All Industry': 8, 'Hi-Tech': 10, BFS: 9, 'Mfg & Auto': 8, 'Health & Pharma': 9, 'Retail & CS': 8, 'Transp & Log': 6, 'Ent & Media': 7, 'Energy & Util': 8, 'Prof Serv': 9, 'BPO/GBS': 7 }
    }
  }
};

const cities = ['Bangalore', 'Hyderabad', 'Delhi NCR', 'Pune', 'Mumbai', 'Chennai', 'Kolkata', 'Tier II'];


const industries = [
  'Hi-Tech',
  'BFS',
  'Mfg & Auto',
  'Health & Pharma',
  'Retail & CS',
  'Transp & Log',
  'Ent & Media',
  'Energy & Util',
  'Prof Serv',
  'BPO/GBS'
];

export default function SalaryCalculator() {
  const [jobRole, setJobRole] = useState('');
  const [currentSalary, setCurrentSalary] = useState('');
  const [city, setCity] = useState('');
  const [seniority, setSeniority] = useState('');
  const [industry, setIndustry] = useState('');
  const [result, setResult] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const calculateIdealSalary = () => {
    if (!jobRole || !currentSalary || !city || !seniority || !industry) {
      alert('Please fill in all fields');
      return;
    }

    const roleData = salaryData[jobRole];
    if (!roleData) return;

    // Get city-based salary
    const citySalary = roleData.cityData[seniority]?.[city] || 0;
    
    // Get industry-based salary
    const industrySalary = roleData.industryData[seniority]?.[industry] || 0;
    
    // Calculate weighted average (60% city, 40% industry)
    const idealSalary = (citySalary * 0.6 + industrySalary * 0.4);
    
    // Convert current salary from rupees to LPA
    const currentInLPA = parseFloat(currentSalary) / 100000;
    const ideal = parseFloat(idealSalary);
    const difference = currentInLPA - ideal; // Current minus ideal (positive if overpaid, negative if underpaid)
    const percentageDiff = ((Math.abs(difference) / ideal) * 100).toFixed(1);

    setResult({
      ideal: ideal.toFixed(1),
      current: currentInLPA.toFixed(1),
      currentRupees: currentSalary,
      difference: Math.abs(difference).toFixed(1),
      percentage: percentageDiff,
      isUnderpaid: difference < 0 // If current < ideal, then underpaid
    });
    setShowResult(true);
    setTimeout(() => {
    window.scrollTo({ top: 800, behavior: 'smooth' });
  }, 50);
  };

  const reset = () => {
    setJobRole('');
    setCurrentSalary('');
    setCity('');
    setSeniority('');
    setIndustry('');
    setResult(null);
    setShowResult(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1a0b2e',
      padding: '40px 20px',
      paddingTop: '60px',
      fontFamily: '"Inter", -apple-system, system-ui, sans-serif'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        {/* Keka Branding Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '48px'
        }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
            padding: '8px 12px',
            borderRadius: '24px',
            marginBottom: '24px',
            fontSize: '12px',
            fontWeight: '600',
            color: '#fff',
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
          Salary Benchmarking Calculator
          </div>
          <h1 style={{
            fontSize: '50px',
            fontWeight: '800',
            color: '#fff',
            marginBottom: '16px',
            letterSpacing: '-0.02em',
            lineHeight: '1.1'
          }}>
            HRs, Are You <span style={{
              background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>Underpaid?</span>
          </h1>
          <p style={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '18px',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Discover your true market value with India's 1st HR Salary Benchmarking Calculator
          </p>
        </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(20px)',
          borderRadius: '24px',
          padding: 'clamp(16px, 4vw, 48px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)'
        }}>

        {!showResult ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
            <div>
              <label style={{
                display: 'block',
                color: '#EC4899',
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Job Role
              </label>
              <select
                value={jobRole}
                onChange={(e) => {
                  setJobRole(e.target.value);
                  setSeniority('');
                }}
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  color: '#fff',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
              >
                <option value="">Select your role</option>
                {Object.keys(salaryData).map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>

            {jobRole && (
              <div style={{ animation: 'fadeIn 0.4s ease' }}>
                <label style={{
                  display: 'block',
                  color: '#EC4899',
                  fontSize: '14px',
                  fontWeight: '600',
                  marginBottom: '10px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  Seniority Level
                </label>
                <select
                  value={seniority}
                  onChange={(e) => setSeniority(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '12px',
                    color: '#fff',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                >
                  <option value="">Select your level</option>
                  {salaryData[jobRole].seniority.map(level => (
                    <option key={level} value={level}>{level}</option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label style={{
                display: 'block',
                color: '#EC4899',
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Current Annual Salary (₹)
              </label>
              <input
                type="number"
                value={currentSalary}
                onChange={(e) => setCurrentSalary(e.target.value)}
                placeholder="e.g., 700000"
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  color: '#fff',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                color: '#EC4899',
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                City
              </label>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  color: '#fff',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
              >
                <option value="">Select your city</option>
                {cities.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{
                display: 'block',
                color: '#EC4899',
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Industry
              </label>
              <select
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  color: '#fff',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
              >
                <option value="">Select your industry</option>
                {industries.map(ind => (
                  <option key={ind} value={ind}>{ind}</option>
                ))}
              </select>
            </div>

            <button
              onClick={calculateIdealSalary}
              style={{
                marginTop: '12px',
                padding: '18px 36px',
                background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
                border: 'none',
                borderRadius: '12px',
                color: '#fff',
                fontSize: '18px',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                boxShadow: '0 8px 24px rgba(124, 58, 237, 0.4)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 32px rgba(124, 58, 237, 0.5)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 24px rgba(124, 58, 237, 0.4)';
              }}
            >
              Compare My Salary
            </button>
          </div>
        ) : (
          <div style={{ animation: 'fadeIn 0.5s ease' }}>
            <div style={{
              background: result.isUnderpaid 
                ? 'linear-gradient(135deg, rgba(255, 87, 87, 0.1) 0%, rgba(255, 87, 87, 0.05) 100%)'
                : 'linear-gradient(135deg, rgba(0, 255, 136, 0.1) 0%, rgba(0, 255, 136, 0.05) 100%)',
              border: `2px solid ${result.isUnderpaid ? 'rgba(255, 87, 87, 0.3)' : 'rgba(0, 255, 136, 0.3)'}`,
              borderRadius: '16px',
              padding: 'clamp(30px, 5vw, 40px) clamp(10px, 3vw, 40px)',
              marginBottom: '32px',
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: '18px',
                color: 'rgba(255, 255, 255, 0.7)',
                marginBottom: '16px',
                fontWeight: '500'
              }}>
                {result.isUnderpaid ? 'You are underpaid by' : 'You are earning above market by'}
              </div>
              <div  style={{
                fontSize: 'clamp(36px, 8vw, 72px)',  // responsive magic
                fontWeight: '900',
                color: result.isUnderpaid ? '#ff5757' : '#00ff88',
                marginBottom: '8px',
                lineHeight: '1'
              }}>
                {Math.abs(parseFloat(result.percentage))}%
              </div>
              <div style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.6)',
                marginBottom: '32px'
              }}>
                ₹{Math.abs(parseFloat(result.difference))} LPA {result.isUnderpaid ? 'below' : 'above'} market rate
              </div>
              
              <div  style={{ 
                display: 'flex', 
                justifyContent: 'space-around',
                flexDirection: 'column',
                gap: '24px',
                paddingTop: '10px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div>
                  <div style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.5)',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em'
                  }}>
                    Current Salary
                  </div>
                  <div style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#fff'
                  }}>
                    ₹{parseFloat(result.currentRupees).toLocaleString('en-IN')}
                  </div>
                  <div style={{
                    fontSize: '16px',
                    color: 'rgba(255, 255, 255, 0.6)',
                    marginTop: '4px'
                  }}>
                    ({result.current} LPA)
                  </div>
                </div>
                <div>
                  <div style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.5)',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em'
                  }}>
                    Market Rate
                  </div>
                  <div style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#EC4899'
                  }}>
                    ₹{(parseFloat(result.ideal) * 100000).toLocaleString('en-IN')}
                  </div>
                  <div style={{
                    fontSize: '16px',
                    color: 'rgba(255, 255, 255, 0.6)',
                    marginTop: '4px'
                  }}>
                    ({result.ideal} LPA)
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.03)',
              borderRadius: '12px',
              padding: '24px',
              marginBottom: '24px'
            }}>
              <h3
  style={{
    cssText: 'color: #EC4899 !important; font-size:16px; margin-bottom:16px; font-weight:600; text-transform:uppercase; letter-spacing:0.05em;'
  }}
>

                Your Profile
              </h3>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '14px'
              }}>
                <div>
                  <strong style={{ color: '#EC4899' }}>Role:</strong> {jobRole}
                </div>
                <div>
                  <strong style={{ color: '#EC4899' }}>Level:</strong> {seniority}
                </div>
                <div>
                  <strong style={{ color: '#EC4899' }}>City:</strong> {city}
                </div>
                <div>
                  <strong style={{ color: '#EC4899' }}>Industry:</strong> {industry}
                </div>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '16px',
              marginTop: '24px'
            }}>
              <button
                onClick={reset}
                style={{
                  flex: 1,
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  color: '#fff',
                  padding: 'clamp(5px, 2vw, 16px)',
                  fontSize: 'clamp(13px, 2.5vw, 16px)',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                }}
              >
                Calculate Again
              </button>

              <button
              className='openPopup'
                 onClick={() => {
    const popup = document.querySelector('.popupContainer');

    popup.style.display =
      popup.style.display === 'none' || popup.style.display === ''
        ? 'flex'
        : 'none';
  }}
                style={{
                  flex: 1,
                  background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
                  border: 'none',
                  borderRadius: '12px',
                  color: '#fff',
                  padding: 'clamp(5px, 2vw, 16px)',
                  fontSize: 'clamp(13px, 2.5vw, 16px)',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  boxShadow: '0 8px 24px rgba(124, 58, 237, 0.4)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 12px 32px rgba(124, 58, 237, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 24px rgba(124, 58, 237, 0.4)';
                }}
              >
                Download Report
              </button>
            </div>
          </div>
        )}

        </div>

        <div style={{
          marginTop: '15px',
          padding: '24px',
          background: 'rgba(124, 58, 237, 0.1)',
          borderRadius: '12px',
          border: '1px solid rgba(236, 72, 153, 0.2)',
          textAlign: 'center'
        }}>
          <p style={{
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '13px',
            lineHeight: '1.6',
            margin: 0
          }}>
            Data sourced from <strong style={{ color: '#EC4899' }}>India HR Salary Benchmarking Report 2025-2026</strong> by <strong style={{ color: '#7C3AED' }}>Keka</strong>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        select, input {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }

        select:hover, input:hover {
          border-color: rgba(236, 72, 153, 0.3) !important;
        }

        select:focus, input:focus {
          border-color: #EC4899 !important;
          box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.2) !important;
        }

        option {
          background: #1a0b2e;
          color: #fff;
        }
      `}</style>
    </div>
  );
}
